import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableDataSouce, TableFilter, TableState, YshTableSetComponent } from "../../components/ysh-table-set/ysh-table-set.component";
import { Router } from '@angular/router';
import { AppRoutes } from '../../app.routes';
import { Order, OrderStatus } from '../../models/order';
import { OrderService } from '../../services/api/order/order.services';
import { YshBadgeComponent } from '../../components/ysh-badge/ysh-badge.component';
import { CompanyService } from '../../services/api/company/company.service';
import { mergeMap } from 'rxjs';

@Component({
    selector: 'app-inspections',
    templateUrl: './inspections.component.html',
    styleUrl: './inspections.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [YshTableSetComponent]
})
export class InspectionsComponent implements OnInit {

  @Input() companyUid?: string;

  dataSource: TableDataSouce<Order>;

  constructor(
    private companyService: CompanyService,
    private orderService: OrderService, 
    private router: Router) {}

  ngOnInit(): void {
    this.dataSource = {
      title: 'Inspection History',
      // Sorting/filtering fails on 'getter' field values, so only 'Completed'
      // is sortable — it maps to the real 'timeCompleted' field via sortParam.
      columns: [
        { title: 'Description', field: 'serviceNameString', cellSize: 'large' },
        { title: 'Team Member', field: 'userString' },
        { title: 'Vehicle', field: 'vehicleDescriptionString' },
        { title: 'VIN', field: 'vehicleVinString' },
        { title: 'Completed', field: 'timeCompletedString', sortable: true, sortParam: 'timeCompleted' },
        { title: 'Result', field: 'inspectionResultString', component: YshBadgeComponent }
      ],
      filters:[{ type: TableFilter.Search }],
      defaultSort: { field: 'timeCompletedString', order: 'desc' },

      actions: [],
      displayRowNav: true,
      noDataMessage: 'Inspections will be listed here after they are completed.',
      load: (state, status = OrderStatus.Complete) => this.loadData(state, status),
    }
  }
  
  didTapItem(order: Order) {
    this.router.navigate([AppRoutes.Inspections, order.uid]);
  }

  private loadData(state: TableState, status = OrderStatus.Complete){
    return this.companyService.get(this.companyUid).pipe(mergeMap(company => {
      return this.orderService.getMany({ ...state, serviceTypeName: 'inspection' }, status, company?.accountUid)
    }));
  }
  
}
